export default __webpack_public_path__ + "images/home-theater-install-service.jpg";